<div class="card">
  <div class="card-body d-flex flex-column">
    <div class="my-4">
      <div [routerLink]="['/login']" class=" logo mx-auto"></div>
    </div>
    <h3 class="text-center mt-1 fw-bold">Bienvenido</h3>
    <div class="text-center my-2">Por favor ingresa los siguientes datos para solicitar tu usuario</div>
    <form class="row d-flex flex-column align-items-center mt-4 h-100"
          [formGroup]="accountRequestForm"
          (ngSubmit)="submit()">
      <div class="col-5 p-0 mb-2">
        <label for="rutProveedor" class="form-label">Rut Proveedor</label>
        <input
          type="text"
          class="form-control"
          id="rutProveedor"
          placeholder="98765432-1"
          formControlName="rutProveedor"
          appInputRut
          maxlength="20"
          (change)="onChangeRut()"
        />
        <div *ngIf="invalidRutProveedor" class="invalid-message">Por favor ingrese un rut de proveedor valido</div>
      </div>
      <div class="col-5 p-0 my-2">
        <label for="nombreProveedor" class="form-label">Proveedor</label>
        <input
          type="text"
          class="form-control"
          id="nombreProveedor"
          placeholder="Nombre de proveedor"
          formControlName="nombreProveedor"
          readonly
        />
      </div>
      <div class="col-5 p-0 my-2">
        <label for="name" class="form-label">Nombre</label>
        <input
          type="email"
          class="form-control"
          id="name"
          placeholder="Nombre del usuario"
          maxlength="50"
          formControlName="name"/>
        <div *ngIf="invalidName" class="invalid-message">Por favor, ingrese su nombre</div>
      </div>
      <div class="col-5 p-0 my-2">
        <label for="lastnames" class="form-label">Apellidos</label>
        <input
          type="email"
          class="form-control"
          id="lastnames"
          placeholder="Apellidos del usuario"
          maxlength="50"
          formControlName="lastnames"/>
        <div *ngIf="invalidLastnames" class="invalid-message">Por favor, ingrese su apellido</div>
      </div>
      <div class="col-5 p-0 my-2">
        <label for="email" class="form-label">Correo electrónico</label>
        <input
          type="email"
          class="form-control"
          id="email"
          placeholder="micorreo@mail.com"
          formControlName="email"
          maxlength="50"
          />
        <div *ngIf="invalidEmail" class="invalid-message">Por favor ingrese un Correo electrónico válido</div>
      </div>
      <div class="col-5 p-0">
        <label for="phone" class="form-label">Teléfono</label>
        <div class="input-group prefix">
        <span _ngcontent-gcw-c84="" id="basic-addon3" class="input-group-icon start text-center">+56</span>
        <input
          type="tel"
          class="form-control"
          id="phone"
          placeholder="987654321"
          formControlName="phone"
          maxlength="9"
          minlength="9"
          appInputPhone/>
        </div>
        <div *ngIf="invalidPhone" class="invalid-message">Por favor ingrese un teléfono válido</div>
      </div>
      <div class="col-4 d-flex justify-content-center my-4">
        <div>
          <re-captcha formControlName="recaptcha"></re-captcha>
        </div>
      </div>
      <div class="col-5 d-flex flex-column p-0">
        <button class="btn btn-primary mb-1" type="submit" [disabled]="accountRequestForm.invalid">Ingresar</button>
      </div>
    </form>
    <!-- <div class="alert alert-info col-8 align-self-center mt-5" role="alert">
      <p class="mensaje-soporte">Ante cualquier inconveniente con la solicitud de usuario por favor
         comunicarse al <a  class="alert-link">soporteti@agunsa.cl</a>
      </p>
    </div> -->
  </div>
</div>


